import type {
  QueryParam,
  QueryParams,
} from '@/modules/common/context/QueryParams/models';

import {schema} from '@/modules/common/context/QueryParams/schema';
import {isValidUrlEntry} from '@/modules/common/context/QueryParams/utils/isValidUrlEntry';
import {stringifyWithSchema} from '@/modules/common/context/QueryParams/utils/stringifyWithSchema';

export const stringifyQueryParams = (
  queryParams: Partial<QueryParams>
): string => {
  const queryParamEntries = Object.entries(
    stringifyWithSchema({
      queryParams,
      schema,
    })
  ).filter(([key, value]) => isValidUrlEntry(key as QueryParam, value));

  return new URLSearchParams(queryParamEntries).toString();
};
